module.exports = __webpack_public_path__ + "img/lineas-de-transmision-electrica.8e23f1fb.webp";